module.exports = __webpack_public_path__ + "img/notification-message.9184d0f9.svg";